import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL, APIURLCOT } from "../../../Config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ClientDetailCTLoanDetail from "../../ClientDetailCTLoanDetail";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function AppHelpline() {
  const tableAppHelpline = React.useRef(null);
  const tableCloseHelplineList = React.useRef(null);

  const emailid = localStorage.getItem("emailId");
  const todayDate = new Date().toISOString().split("T")[0];

  // Calculate the date 7 days before today
  const sevenDaysBeforeDate = new Date();
  sevenDaysBeforeDate.setDate(1);
  const formattedSevenDaysBeforeDate = sevenDaysBeforeDate
    .toISOString()
    .split("T")[0];
  const token = localStorage.getItem("token");

  const [selectDate, setSelectDate] = useState(false);

  const [activeTab, setActiveTab] = useState("profile");
  const [helplineListDateValue1, setHelplineListDateValue1] =
    useState(todayDate); // Default to today’s date
  const [helplineListDateValue2, setHelplineListDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );
  const [isLoader, setIsLoader] = useState(false);
  const [showPrePage, setShowPrePage] = useState(100);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [message, setMessage] = useState("");

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [helpline, setHelpline] = useState([]);
  const [closeHelplineList, setCloseHelplineList] = useState([]);
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  useEffect(() => {
    getHelpline();
  }, []);

  const getHelpline = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getHelpline`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setHelpline(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const getCloseHelplineList = () => {
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/getdatahelpline/${helplineListDateValue2}/${helplineListDateValue1}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setCloseHelplineList(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const closeIssue = (entryDate, id) => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/closeissue`, {
        method: "POST",
        data: {
          entryDate: entryDate,
          id: id,
          code: "helpline",
          ownerEmail: emailid,
        },
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        getHelpline();
        toast.success("Close query successfully");
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const remarkChange = (e) => {
    setMessage(e.target.value);
  };
  const handleSubmit = (remark) => {
    console.log("remark", remark);
    console.log("message", message);
    if (message === "") {
      toast.warning("All field required");
    } else {
      const data = {
        id: remark?.id,
        entryDate: remark?.entryDate,
        ticketClosingRemark: message,
        ownerEmail: emailid,
      };
      axios
        .request(`${APIURLCOT}/setreply`, {
          method: "POST",
          data: data,
          headers: {
            Authentication: token,

            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response:::::::", response);
          setShowModal(false);
          setMessage("");
          toast.success(response?.data);
          getHelpline();
          setIsLoader(false);
        })
        .catch((error) => {
          setIsLoader(false);
          console.log(error);
        });
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const handleHelplineList = () => {
    getCloseHelplineList();
  };
  useEffect(() => {
    if (activeTab === "profile") {
      getHelpline();
    }
    if (activeTab === "clh") {
      setSelectDate(false);
      const todayDate = new Date();
      setHelplineListDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setHelplineListDateValue2(
        moment(sevenDaysBeforeDate).format("YYYY-MM-DD")
      );
      getCloseHelplineList();
    }
  }, [activeTab]);
  return (
    <div className={width ? "" : "p-3"}>
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT  tab-item ${
                activeTab === "profile" ? "active" : ""
              }`}
              id="profile"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "profile"}
              onClick={() => handleTabClick("profile")}
            >
              App Helpline
            </button>
          </li>
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT  tab-item ${
                activeTab === "clh" ? "active" : ""
              }`}
              id="clh"
              data-bs-toggle="tab"
              data-bs-target="#clh"
              type="button"
              role="tab"
              aria-controls="clh"
              aria-selected={activeTab === "clh"}
              onClick={() => handleTabClick("clh")}
            >
              List of Close Helpline
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className={`tab-pane fade ${
              activeTab === "profile" ? "show active" : ""
            }`}
            id="profile"
            role="tabpanel"
            aria-labelledby="profile"
          >
            {showSearch ? (
              <>
                <div className="p-3 d-flex justify-content-start mt-3">
                  <button
                    className="btn btn-secondary"
                    style={{ width: "100px" }}
                    onClick={() => {
                      setShowSearch(false);
                    }}
                  >
                    Back
                  </button>
                </div>
                <div className="p-3 pt-2">
                  <ClientDetailCTLoanDetail lid={lid} />
                </div>
              </>
            ) : (
              <div className="pt-3">
                <div className="card">
                  <DownloadTableExcel
                    filename="AppHelpline"
                    sheet="users"
                    currentTableRef={tableAppHelpline.current}
                  >
                    <button
                      className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                      style={{
                        width: "120px",
                        backgroundColor: "black",
                        color: "white",
                      }}
                    >
                      Download
                    </button>
                  </DownloadTableExcel>
                  <div className="p-3 pt-4">
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>
                                Entry date
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Entry time
                              </th>
                              <th style={{ textAlign: "center" }}>LID</th>
                              <th style={{ textAlign: "center" }}>
                                Client Type
                              </th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>
                                Branch Name
                              </th>
                              {/* <th style={{ textAlign: "center" }}>Issue</th> */}
                              <th style={{ textAlign: "center" }}>
                                Mobile No.
                              </th>
                              <th style={{ textAlign: "center" }}>Address</th>

                              {/* <th style={{ textAlign: "center" }}>Remarks</th> */}
                              <th style={{ textAlign: "center" }}>
                                Close Ticket
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {helpline?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td style={{ textAlign: "center" }}>
                                  {" "}
                                  {item.entryDate
                                    ? moment(item.entryDate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.entryDate
                                    ? moment(item.entryDate).format("HH:mm:ss")
                                    : ""}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.loanId) {
                                      setLid(item.loanId);
                                      setShowSearch(true);
                                    }
                                  }}
                                >
                                  {item.loanId}
                                </td>
                                <td>{item.lender}</td>

                                <td>{item.clientName}</td>
                                <td>{item.branchName || "-"}</td>
                                <td>{item.mobileNo}</td>
                                <td>{item?.address}</td>
                                {/* {item?.closingRemark === "" ||
                                item?.closingRemark === null ? (
                                  <td>
                                    <div className="d-flex justify-content-center">
                                      <button
                                        className="btn btn-success"
                                        style={{ width: "150px" }}
                                        onClick={() => {
                                          setRemark(item);
                                          setShowModal(true);
                                        }}
                                      >
                                        Reply
                                      </button>
                                    </div>
                                  </td>
                                ) : (
                                  <td>{item?.closingRemark}</td>
                                )} */}
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn btn-danger"
                                      style={{ width: "150px" }}
                                      onClick={() => {
                                        closeIssue(item.entryDate, item.id);
                                      }}
                                    >
                                      Close
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <Modal
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          style={{ background: "rgb(255 255 255 / 40%)" }}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Remark</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <input
                              type="text"
                              value={message}
                              onChange={remarkChange}
                              style={{
                                width: "100%",
                                padding: "10px",
                                boxSizing: "border-box",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                marginTop: "10px",
                                fontSize: "18px",
                              }}
                            />
                            <div className="d-flex mt-3 justify-content-end">
                              <button
                                className="btn btn-secondary"
                                style={{ width: "100px" }}
                                onClick={() => setShowModal(false)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-success ml-2"
                                style={{
                                  width: "100px",
                                  background: "#66a725",
                                }}
                                onClick={() => handleSubmit(remark)}
                              >
                                Submit
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>
                        {helpline && helpline.length !== 0 && (
                          <Pagination
                            showPrePage={showPrePage}
                            onPaginationChange={onPaginationChange}
                            total={helpline.length}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <table
              className="table table-striped mt-3 "
              style={{ display: "none" }}
              ref={tableAppHelpline}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th style={{ textAlign: "center" }}>Entry date</th>
                  <th style={{ textAlign: "center" }}>Entry time</th>
                  <th style={{ textAlign: "center" }}>LID</th>
                  <th style={{ textAlign: "center" }}>Type</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Issue</th>
                  <th style={{ textAlign: "center" }}>Mobile No.</th>
                  <th style={{ textAlign: "center" }}>Address</th>
                  <th style={{ textAlign: "center" }}>Close Ticket</th>
                </tr>
              </thead>

              <tbody>
                {helpline?.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td style={{ textAlign: "center" }}>
                      {" "}
                      {item.entryDate
                        ? moment(item.entryDate).format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.entryDate
                        ? moment(item.entryDate).format("HH:mm:ss")
                        : ""}
                    </td>
                    <td
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                      onClick={() => {
                        if (item.loanId) {
                          setLid(item.loanId);
                          setShowSearch(true);
                        }
                      }}
                    >
                      {item.loanId}
                    </td>
                    <td>{item.lender}</td>

                    <td>{item.clientName}</td>
                    <td>{item.mobileNo}</td>
                    <td>{item.address}</td>
                    {item?.closingRemark === "" ||
                    item?.closingRemark === null ? (
                      <td>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn btn-success"
                            style={{ width: "150px" }}
                            onClick={() => {
                              setRemark(item);
                              setShowModal(true);
                            }}
                          >
                            Reply
                          </button>
                        </div>
                      </td>
                    ) : (
                      <td>{item?.closingRemark}</td>
                    )}
                    <td>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-danger"
                          style={{ width: "150px" }}
                          onClick={() => {
                            closeIssue(item.entryDate, item.id);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            className={`tab-pane fade ${
              activeTab === "clh" ? "show active" : ""
            }`}
            id="clh"
            role="tabpanel"
            aria-labelledby="clh"
          >
            <div className="pt-3">
              <div className="card">
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <DownloadTableExcel
                      filename="CloseHelplineList"
                      sheet="users"
                      currentTableRef={tableCloseHelplineList.current}
                    >
                      <button
                        className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                        style={{
                          width: "120px",
                          backgroundColor: "black",
                          color: "white",
                        }}
                      >
                        Download
                      </button>
                    </DownloadTableExcel>
                  </div>
                  <div className="d-flex flex-grow-2 p-3">
                    {!selectDate ? (
                      <button
                        className="btn btn-info"
                        style={{ width: "150px" }}
                        onClick={() => setSelectDate(true)}
                      >
                        Select Date
                      </button>
                    ) : (
                      <div className="d-flex" style={{ width: "500px" }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <div>
                            <DatePicker
                              className="ml-2"
                              label="From Date"
                              value={
                                helplineListDateValue2
                                  ? new Date(helplineListDateValue2)
                                  : null
                              } // Ensure value is a Date object
                              format="dd-MM-yyyy"
                              onChange={(date) =>
                                setHelplineListDateValue2(
                                  date
                                    ? moment(date).format("YYYY-MM-DD")
                                    : null
                                )
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </div>
                          <div>
                            <DatePicker
                              className="ml-2"
                              label="To Date"
                              value={
                                helplineListDateValue1
                                  ? new Date(helplineListDateValue1)
                                  : null
                              } // Ensure value is a Date object
                              format="dd-MM-yyyy"
                              onChange={(date) =>
                                setHelplineListDateValue1(
                                  date
                                    ? moment(date).format("YYYY-MM-DD")
                                    : null
                                )
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </div>
                        </LocalizationProvider>
                        <div className="mt-2 mx-2">
                          <button
                            className="btn btn-success"
                            style={{
                              background: "#66a725",
                              width: "100px",
                            }}
                            onClick={() => handleHelplineList()}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="p-3 ">
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Entry Date</th>
                            <th style={{ textAlign: "center" }}>Mobile No.</th>
                            {/* <th style={{ textAlign: "center" }}>Email Type</th> */}
                            {/* <th style={{ textAlign: "center" }}>Remark</th>
                            <th style={{ textAlign: "center" }}>
                              Closing Remark
                            </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {closeHelplineList.length > 0 ? (
                            closeHelplineList.map((item, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  {index + 1}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.entryDate
                                    ? moment(item.entryDate).format(
                                        "DD-MM-YYYY, h:mm:ss A"
                                      )
                                    : ""}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.mobileno}
                                </td>
                                {/* <td style={{ textAlign: "center" }}>
                                  {item.emailType}
                                </td> */}
                                {/* <td style={{ textAlign: "center" }}>
                                  {item.remark}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.ticketClosingRemark}
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableCloseHelplineList}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry Date</th>
                        <th style={{ textAlign: "center" }}>Mobile No.</th>
                        {/* <th style={{ textAlign: "center" }}>Email Type</th> */}
                        <th style={{ textAlign: "center" }}>Remark</th>
                        <th style={{ textAlign: "center" }}>Closing Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      {closeHelplineList.length > 0 ? (
                        closeHelplineList.map((item, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center" }}>{index + 1}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.entryDate
                                ? moment(item.entryDate).format(
                                    "DD-MM-YYYY, h:mm:ss A"
                                  )
                                : ""}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.mobileno}
                            </td>
                            {/* <td style={{ textAlign: "center" }}>
                              {item.emailType}
                            </td> */}
                            <td style={{ textAlign: "center" }}>
                              {item.remark}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.ticketClosingRemark}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
